import { View, type ViewProps } from "react-native";

import { cn } from "@/lib/ui/cn";

/**
 * The framed-surface token set every card shares. Exported so a surface that can't route through
 * `<Card>` — e.g. Book's desktop hero, whose wrapper has to stay a plain `<View>` to keep a
 * stable fiber position across the breakpoint — still moves in lockstep with the card tokens.
 */
export const CARD_SURFACE_CLASS = "rounded-[28px] bg-surface p-5";

/** A framed surface that groups related content. */
export function Card({ className, ...rest }: ViewProps & { className?: string; }) {
  return <View className={cn(CARD_SURFACE_CLASS, "workspace-card", className)} {...rest} />;
}
